import { artifactStatusMap } from '../Constants/Files';
//making a shallowcopy of file object with new File function.
//since it is a blob object normal shallow copy results in empty object.
const ShallowCopyFileObject = (file) => {
	const newFile = new File([file], file.name, {
		type: file.type,
		lastModified: file.lastModified,
		lastModifiedDate: file.lastModifiedDate,
	});
	newFile['isPrimary'] = file['isPrimary'] ?? false;
	return newFile;
};
export default ShallowCopyFileObject;

// Check if the artifact status is one of the terminal statuses.
export const isTerminalStatus = (status) => {
	const terminalStatuses = [
		artifactStatusMap.approved.value,
		artifactStatusMap.published.value,
		artifactStatusMap.live.value,
	];
	return terminalStatuses.includes(status);
};
// check to see if the source file has at least one published artifact.
export const hasSimilarTypePublishedArtifacts = (srcFile, type) => {
	const hasPublishedArtifact = srcFile?.artifacts?.some(
		(artifact) => isTerminalStatus(artifact.status.toLowerCase()) && artifact.type === type,
	);
	return hasPublishedArtifact;
};
